import React from 'react'

const QRCode = ({ config, qrUrl }) =>
  <div className="overlay p-1 rounded-3 qr-code-container">
    <div className="bg-white p-2 rounded-2">
      <img
        alt="QR Code"
        src={`https://api.qrserver.com/v1/create-qr-code/?${
          new URLSearchParams({ data: qrUrl, size: '240x240' })
        }`}
        style={{ width: '5rem', height: '5rem' }}
      />
    </div>
  </div>

export default QRCode
